import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.MinSuspectScore
const label = visitFilterLabelMap[key]

export const suspectScoreColumn = () =>
  columnHelper.accessor((row) => row.suspect_score, {
    id: 'suspectScore',
    header: 'Suspect Score',
    sortingFn: 'basic',
    cell: ({ row }) => {
      const suspectScore = row.original.suspect_score

      if (suspectScore == null) {
        return <Unavailable />
      }

      return (
        <CellAction
          search={(old) => ({ ...old, [key]: suspectScore })}
          field={label}
          className='text-end'
          contentClassName='group-hover/target:pr-9'
        >
          <Typography className='font-mono text-end'>{suspectScore}</Typography>
        </CellAction>
      )
    },
  })
